import { searchStores as baseSearchStores } from '@libs/api-proxy-client';
import { SearchStore, StoreSearchParams } from '@libs/common-types';

const NO_STORES = [] as SearchStore[];

export async function searchStores(params: StoreSearchParams) {
    const response = await baseSearchStores(params);
    return response || NO_STORES;
}
